import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { TicketType } from '@cbgms/api'
import { Dropdown } from '@carsys/form'

export const TicketTypeFormFields: React.FC<{}> = () => {
  const { t } = useTranslation()

  const options = [
    { text: t('Contact.VehicleRelated'), value: TicketType.VehicleRelatedQuestion },
    { text: t('Contact.PartsOnVehicleRelated'), value: TicketType.PartVehicleLinkageQuestion },
    { text: t('Contact.PartRelated'), value: TicketType.PartRelatedQuestion },
    { text: t('Contact.PartAvailability'), value: TicketType.PartAvailability },
    { text: t('Contact.ITRelated'), value: TicketType.ITRelatedQuestion },
    { text: t('Contact.MyAccount'), value: TicketType.GeneralTicket },
    { text: t('Contact.Suggestion'), value: TicketType.Suggestion }
  ]

  return (
    <Grid container direction='column' spacing={1.5}>
      <Grid item>
        <Typography variant='body1' align='left' gutterBottom>
          {t('Contact.SelectTopic')}
        </Typography>
      </Grid>
      <Grid item>
        <Dropdown name='TicketType' options={options} />
      </Grid>
    </Grid>
  )
}
